import { Component,Input, OnInit } from '@angular/core';
import {BrowseComponent} from "@shared/components/browse/abstract.browse.component";
import {Pagination} from "@core/bean/pagination";
import {CommonsService} from "@core/service/commons.service";
import {NzModalService} from "ng-zorro-antd";
import {HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {BrowseConfig} from "@core/bean/browse-config";
import {PersonService} from "../../../../routes/jy-org/person/service/person.service";
import {environment} from "../../../../../environments/environment";
import {SoaService} from "../../../../routes/jy-srm/soa/soa.service";
import {PlantService} from "../plant/plant.service";


@Component({
  selector: 'app-soa.browse',
  templateUrl: './soa.browse.component.html',
  styles: []
})
export class SoaBrowseComponent implements OnInit {

  static componentName = 'SoaBrowseComponent';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  headUrl = environment.SERVER_URL.substr(0, environment.SERVER_URL.length - 1);

  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private soaService:SoaService) {

    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return soaService.query(params);
    }

  }

  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }


  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }


}
